import { Component } from "solid-js";

export interface TypeIconProps {
  typeName: string;
}

const glyphs: Record<string, [string, string]> = {
  Epic: ["E", "bg-signal-cyan-tint text-signal-cyan"],
  Story: ["S", "bg-signal-green-tint text-signal-green"],
  Task: ["T", "bg-signal-blue-tint text-signal-blue"],
  Bug: ["B", "bg-signal-red-tint text-signal-red"],
};

/** 15px mono glyph tile for a work item type; decorative — the type name is shown elsewhere. */
export const TypeIcon: Component<TypeIconProps> = (props) => {
  const glyph = () =>
    glyphs[props.typeName] ?? [
      props.typeName.charAt(0).toUpperCase(),
      "bg-sunken text-ink-2",
    ];
  return (
    <span
      aria-hidden="true"
      title={props.typeName}
      class={
        "inline-flex items-center justify-center w-[15px] h-[15px] rounded-sm font-mono text-[10px] font-semibold leading-none flex-shrink-0 " +
        glyph()[1]
      }
    >
      {glyph()[0]}
    </span>
  );
};
